import { FC } from "react";
import { CashBuilderFormProps } from "./types";
import { Row } from "../../containers";
import { FileInput, NumberInput, SelectorInput, TextInput } from "../../inputs";
import { CashType, Customer } from "../../../types";
import { useGeneralStore } from "../../../stores";
import { CASH_TYPE_LIST } from "../../../constants/misc";

const CashBuilderForm: FC<CashBuilderFormProps> = ({
  cashBuilder,
  setCustomer,
  setDescription,
  setImage,
  setTotalPrice,
  setType,
  readOnly = false,
}) => {
  const customers = useGeneralStore((s) => s.customers);

  return (
    <>
      <Row
        gap={20}
        className="finance-input-row"
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        <SelectorInput<Customer>
          items={customers}
          uniqueKey={"fullname"}
          selected={cashBuilder.customer}
          setSelected={setCustomer || (() => {})}
          stringField={"fullname"}
          renderStrings={["fullname", "phone"]}
          compareFn={(c, v) =>
            c.fullname.toLowerCase().includes(v.toLowerCase()) ||
            c.phone.includes(v)
          }
          label="نام مشتری"
          readOnly={readOnly}
        />

        <TextInput
          label="بابت"
          value={cashBuilder.description}
          setValue={setDescription}
          inputProps={{ readOnly }}
        />

        <NumberInput
          label="مبلغ کل (ریال)"
          value={cashBuilder.total_price}
          setValue={setTotalPrice || (() => {})}
          inputProps={{ readOnly }}
          price
        />
      </Row>

      <Row
        gap={20}
        className="finance-input-row"
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        <SelectorInput<CashType>
          items={CASH_TYPE_LIST}
          uniqueKey={"name"}
          selected={cashBuilder.type}
          setSelected={setType || (() => {})}
          stringField={"fa"}
          renderStrings={["fa"]}
          compareFn={(t, v) => t.fa.toLowerCase().includes(v.toLowerCase())}
          label="نوع نقدی"
          readOnly={readOnly}
        />

        <FileInput
          label="عکس"
          value={cashBuilder.image}
          setValue={setImage || (() => {})}
        />
      </Row>
    </>
  );
};

export default CashBuilderForm;
